// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.properties.amenities.apartments.RentalManagerUserPropertyApartmentAmenityV2WebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  UserPropertyApartmentAmenityCreateResponseV2WebDto,
  UserPropertyApartmentAmenityCreateV2RequestDto,
  UserPropertyApartmentAmenityDeleteV2RequestDto,
} from '../..';

export const RentalManagerUserPropertyApartmentAmenityV2WebApiHandler_create_Path =
  '/api/web/v2/users/properties/amenities/apartments/create';

/**
 * Create a free text apartment amenity
 */
export const RentalManagerUserPropertyApartmentAmenityV2WebApiHandler_create = (
  postData: UserPropertyApartmentAmenityCreateV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    UserPropertyApartmentAmenityCreateV2RequestDto,
    UserPropertyApartmentAmenityCreateResponseV2WebDto
  >(
    {
      endpoint: RentalManagerUserPropertyApartmentAmenityV2WebApiHandler_create_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyApartmentAmenityV2WebApiHandler_delete_Path =
  '/api/web/v2/users/properties/amenities/apartments/delete';

/**
 * Delete a free text apartment amenity
 */
export const RentalManagerUserPropertyApartmentAmenityV2WebApiHandler_delete = (
  postData: UserPropertyApartmentAmenityDeleteV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyApartmentAmenityDeleteV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyApartmentAmenityV2WebApiHandler_delete_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};
